import { useCallback } from 'react';
import { useTranslation } from '@frontend/i18n';
import { Text } from '@frontend/design-system';
import { AddMfaMethodButton } from './add-mfa-method-button';
import { useMFAContext, VerificationContactMethod } from './mfa-context';

type SelectMFAMethodProps = {
  /** Does the user already MFA methods? This alters some copy. Default is false. */
  hasMFAMethods?: boolean;
};

export function SelectMFAMethod({ hasMFAMethods = false }: SelectMFAMethodProps) {
  const { t } = useTranslation('account');
  const addVerificationMethod = useMFAContext((ctx) => ctx.addVerificationMethod);
  const nextStep = useMFAContext((ctx) => ctx.nextStep);

  const addMethod = useCallback(
    (method: VerificationContactMethod) => {
      addVerificationMethod(method);
      nextStep();
    },
    [addVerificationMethod, nextStep]
  );

  return (
    <div>
      {hasMFAMethods && <Text size='medium'>{t('Add More Methods')}</Text>}
      <AddMfaMethodButton
        icon='message'
        label={hasMFAMethods ? t('Add Phone Number') : t('Send Code Via Text')}
        onClick={() => addMethod('sms')}
      />
      <AddMfaMethodButton
        icon='email'
        label={hasMFAMethods ? t('Add Email') : t('Send Code Via Email')}
        onClick={() => addMethod('email')}
      />
    </div>
  );
}
